import React from 'react';

import { Link } from '../../Link';

import * as S from '../styles';

export const PagarmeMenu = () => (
  <>
    <p>PAGAR.ME</p>
    <ul>
      <li>
        <Link target="_blank" to="https://id.pagar.me/" rel="noopener noreferrer">
          Área do cliente
        </Link>
      </li>

      <li>
        <Link target="_blank" to="https://boards.greenhouse.io/pagarme/" rel="noopener noreferrer">
          Veja nossas vagas
        </Link>
      </li>

      <li>
        <Link target="_blank" to="https://pagar.me/documentos/termos-de-uso.pdf" rel="noopener noreferrer">
          Termos de uso
        </Link>
      </li>
      <li>
        <Link to="/aviso-de-cookies">Aviso de cookies</Link>
      </li>
      <li>
        <Link to="/aviso-de-privacidade">Aviso de privacidade</Link>
      </li>
      <li>
        <S.Button className="cmp-revoke-consent">Preferências de Cookies</S.Button>
      </li>
      <li>
        <Link
          target="_blank"
          to="https://docs.stone.com.br/wp-content/uploads/2024/12/politica-institucional_pld-ftp.pdf"
          rel="noopener noreferrer"
        >
          Política Institucional de PLD-FTP
        </Link>
      </li>
      <li>
        <Link target="_blank" to="https://privacidade.pagar.me" rel="noopener noreferrer">
          Portal de Privacidade
        </Link>
      </li>
    </ul>
  </>
);
